import { Button } from "@material-ui/core";
import React from "react";

export default function StakingCreateSelectType() {
  // show 2 buttons: Soft Staking and Normal Staking
  return (
    <div>
      <h1>StakingCreateSelectType</h1>

      <div>
        <Button variant="contained" color="primary" style={{ marginRight: 20 }} href="/admin/staking-create-soft">
          Soft Staking
        </Button>

        <Button variant="contained" color="primary" href="/admin/staking-create-normal">
          Normal Staking
        </Button>
      </div>
    </div>
  );
}
